import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ScrollReveal from "../components/ScrollReveal";
import Seo from "../components/Seo";
import { getYazilimPage } from "../services/api";
import { STRAPI_URL } from "../services/api";
import { useLang } from "../context/LanguageContext";
import defaultYazilim from '../default_datas/pages/defaultYazilim';


const IMAGES = {
  hero: "https://lh3.googleusercontent.com/aida-public/AB6AXuDz2xc_07mGqCyVntXO62oXm9BB6nCmsDiUAtkwWJ7D_iv54C7Ee3_kOBOdMKQz5R2m43Y-XF6pVRkTmzVdA4Zn-iwuTqbgR9REzoxO3_sp9XdjcXdmS1jKWVHsQxYuyPMLg5t3sFRiIn9_7ktWXLd4vKlhjzyVc1T0x8zJUQiCaG8G498VpIjOwd0cHlwNuyI0tPmg1Tpj0ybL1MZcmQyuAA8NmMpZj9iGqC-a94XMJ7Va4Obf-x2AQ9l1XegD1AGup5G4ZBcuz_4",
  grid: "https://lh3.googleusercontent.com/aida-public/AB6AXuBeQKXMj8w-XwEJX2wxPDRGlUeHVMDUnGuy99IwKTC6LNr45h0Wt2QD3EZWcrSRDl5NCI2pZ59mqrIOGabsD_Bc4fjBfT_DcFR_soSIOP_OMuprnWmX2mtcmPO_2eCT6Zc-rA7r_caei2XQlXx666ChifEEdcdGmwBu_7pAkls5d_yxFlYEunKo70Gp6YqOxR7uPUGiYKlAD19V9D_ApE6luHQDHoHAyjhEeu2_NUyUHDYpYri_bnhB0pD5oYsXceZv1inpP29z7aM",
};

const Shimmer = () => (
  <div className="animate-pulse min-h-screen bg-[#f6f8f6] p-10 space-y-10">
    <div className="max-w-[1280px] mx-auto grid grid-cols-2 gap-16 py-20">
      <div className="space-y-6">
        <div className="h-6 w-48 rounded-full bg-gray-200" />
        <div className="h-14 w-3/4 rounded bg-gray-200" />
        <div className="h-6 w-full rounded bg-gray-200" />
        <div className="h-6 w-5/6 rounded bg-gray-200" />
        <div className="flex gap-4">
          <div className="h-14 w-36 rounded-xl bg-gray-200" />
          <div className="h-14 w-36 rounded-xl bg-gray-200" />
        </div>
      </div>
      <div className="h-[400px] rounded-2xl bg-gray-200" />
    </div>
    <div className="max-w-[1280px] mx-auto grid grid-cols-4 gap-6">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="h-48 rounded-2xl bg-gray-200" />
      ))}
    </div>
  </div>
);

const Yazilim = () => {
  const navigate = useNavigate();
  const { lang } = useLang(); // ← dil bilgisi
  const [data, setData] = useState(defaultYazilim);
  const [loading, setLoading] = useState(true);

  // Section seviyesinde dil helper
  const t = (section, field) => {
    return section?.[lang === "en" ? `${field}_en` : field] ?? "";
  };

  // Card/feature item seviyesinde dil helper
  const ti = (item, field) => {
    return item?.[lang === "en" ? `${field}_en` : field] || item?.[field] || "";
  };

  useEffect(() => {
  getYazilimPage()
    .then((res) => {
      if (res?.pageContent) setData(res);   // ← sadece geçerli veri gelirse set et
    })
    .catch(() => {})
    .finally(() => setLoading(false));
}, []);

  if (loading) return <Shimmer />;

  if (!data || !data.pageContent) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-xl text-[#475569]">
          Veri bulunamadı. Strapi'de pageContent alanını kontrol et.
        </p>
      </div>
    );
  }

  const pageContent = data.pageContent ?? [];

  return (
    <>
      <Seo
        title="Yazılım ve Uygulama Yönetimi | RUZY"
        description="Yazılım envanteri, lisans takibi, yama yönetimi ve uygulama güvenliği süreçlerinizi ISO 27001 uyumlu şekilde merkezi olarak yönetin."
        path="/yazilim"
      />

      <div className="min-h-screen bg-[#f6f8f6] font-poppins text-[#0f172a]">
        {pageContent.map((section, idx) => {

          // ===== 1. HERO =====
          if (section.__component === "sections.hero") {
            return (
              <ScrollReveal key={idx} delay={0}>
                <section className="max-w-[1280px] mx-auto px-10 py-20 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                  <div className="flex flex-col gap-8">
                    {t(section, "badge") && (
                      <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-[rgba(15,189,73,0.1)] text-[#4BA18C] text-xs font-bold tracking-[2px] uppercase w-fit">
                        <span className="material-symbols-outlined text-base">verified_user</span>
                        {t(section, "badge")}
                      </div>
                    )}
                    {t(section, "title") && (
                      <h1 className="text-5xl lg:text-6xl font-black leading-tight tracking-tight text-[#0f172a] m-0">
                        {t(section, "title")}
                      </h1>
                    )}
                    {t(section, "description") && (
                      <p className="text-lg leading-relaxed text-[#475569] m-0 max-w-xl">
                        {t(section, "description")}
                      </p>
                    )}
                    <div className="flex gap-4 flex-wrap">
                      <button
                        onClick={() => navigate("/iletisim")}
                        className="inline-flex items-center gap-2 h-14 px-8 text-lg font-bold rounded-xl border-none cursor-pointer bg-[#4BA18C] text-white shadow-lg hover:scale-[1.02] transition-transform"
                      >
                        {lang === "en" ? "Get Started" : "Hemen Başla"}
                        <span className="material-symbols-outlined text-xl">arrow_forward</span>
                      </button>
                      <button
                        onClick={() => navigate("/iletisim")}
                        className="inline-flex items-center h-14 px-8 text-lg font-bold rounded-xl cursor-pointer bg-white text-[#0f172a] border border-[#e2e8f0] hover:bg-[#f8fafc] transition-colors"
                      >
                        {lang === "en" ? "Request Demo" : "Demo Talebi"}
                      </button>
                    </div>
                  </div>

                  <div className="relative">
                    <div className="absolute inset-[-16px] bg-[rgba(15,189,73,0.2)] blur-3xl rounded-full pointer-events-none" />
                    <div className="relative bg-white p-4 rounded-2xl shadow-2xl border border-[rgba(15,189,73,0.1)]">
                      <div
                        className="w-full h-[400px] rounded-xl bg-cover bg-center relative"
                          style={{ backgroundImage: `url('${
                             section.image?.url 
                             ? (section.image.url.startsWith("http") ? section.image.url : `${STRAPI_URL}${section.image.url}`)
                             : IMAGES.hero
                          }')` }}
                      >
                        <div className="absolute inset-0 bg-black/10 rounded-xl" />
                      </div>
                    </div>
                  </div>
                </section>
              </ScrollReveal>
            );
          }

          // ===== 2. STATS SECTION =====
          if (section.__component === "sections.stats-section") {
            const colorMap = {
              blue:    { bg: "bg-[#e0eefd]", text: "text-[#3572d3]" },
              orange:  { bg: "bg-[#fff2e8]", text: "text-[#e85a11]" },
              green:   { bg: "bg-[#e8f5e9]", text: "text-[#06bd49]" },
              default: { bg: "bg-gray-100",  text: "text-gray-600"  },
            };

            return (
              <ScrollReveal key={idx} delay={0.1}>
                <section className="py-8 bg-[#f6f8f6]">
                  <div className="max-w-[1280px] mx-auto px-10 grid grid-cols-1 md:grid-cols-3 gap-6">
                    {(section.stats ?? []).map((s, i) => {
                      const theme = colorMap[s.iconColor?.toLowerCase()] || colorMap.default;
                      return (
                        <div key={i} className="bg-white border border-[#f1f5f9] rounded-2xl p-6 shadow-sm flex items-center gap-6">
                          <div className={`w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 ${theme.bg} ${theme.text}`}>
                            <span className="material-symbols-outlined text-3xl">
                              {s.icon || "help_outline"}
                            </span>
                          </div>
                          <div>
                            {(ti(s, "title") || ti(s, "label")) && (
                              <p className="text-gray-500 text-sm font-semibold uppercase tracking-widest">
                                {ti(s, "title") || ti(s, "label")}
                              </p>
                            )}
                            {s.value && (
                              <h3 className="text-3xl font-black text-[#0f172a] m-0 mb-1 leading-none">
                                {s.value}
                              </h3>
                            )}
                            {s.subText && (
                              <span className={`text-xs font-bold ${(s.isRed ?? false) ? "text-red-500" : "text-[#4BA18C]"}`}>
                                {ti(s, "subText")}
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </section>
              </ScrollReveal>
            );
          }

          // ===== 3. FEATURES SECTION =====
          if (section.__component === "sections.features-section") {
            return (
              <ScrollReveal key={idx} delay={0.2}>
                <section className="py-16 bg-white/50">
                  <div className="max-w-[1280px] mx-auto px-10">
                    <div className="max-w-2xl mb-12">
                      {t(section, "badge") && (
                        <p className="text-xs font-bold tracking-widest text-[#4BA18C] uppercase mb-3">
                          {t(section, "badge")}
                        </p>
                      )}
                      {t(section, "Title") && (
                        <h2 className="text-4xl font-black text-[#0f172a] mb-4">
                          {t(section, "Title")}
                        </h2>
                      )}
                      {t(section, "description") && (
                        <p className="text-base text-[#475569] leading-relaxed m-0">
                          {t(section, "description")}
                        </p>
                      )}
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                      {(section.cards ?? []).map((card, i) => (
                        <div
                          key={i}
                          className="bg-white border border-[#f1f5f9] rounded-2xl p-8 hover:border-[rgba(15,189,73,0.5)] transition-colors group cursor-default"
                        >
                          <div className="w-12 h-12 rounded-xl bg-[rgba(15,189,73,0.1)] text-[#4BA18C] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                            <span className="material-symbols-outlined text-2xl">{card.icon}</span>
                          </div>
                          <h3 className="text-base font-bold text-[#0f172a] mb-3">
                            {ti(card, "title")}
                          </h3>
                          <p className="text-sm text-[#475569] leading-relaxed m-0">
                            {ti(card, "description")}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </section>
              </ScrollReveal>
            );
          }

          // ===== 4. GRID SECTION =====
          if (section.__component === "sections.grid-section") {
            return (
              <ScrollReveal key={idx} delay={0.3}>
                <section className="py-20 bg-[#f6f8f6]">
                  <div className="max-w-[1280px] mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    <div className="rounded-2xl overflow-hidden shadow-2xl border border-[#e2e8f0]">
                      <img 
                        src={
                          section.image?.url 
                          ? (section.image.url.startsWith("http") ? section.image.url : `${STRAPI_URL}${section.image.url}`)
                          : IMAGES.grid
                        } 
                        alt={t(section, "title")}
                        className="w-full h-auto block"
                      />
                    </div>
                    <div className="flex flex-col gap-6">
                      {t(section, "title") && (
                        <h2 className="text-4xl font-black leading-tight text-[#0f172a] m-0">
                          {t(section, "title")}
                        </h2>
                      )}
                      {t(section, "description") && (
                        <p className="text-[15px] text-[#475569] leading-relaxed m-0">
                          {t(section, "description")}
                        </p>
                      )}
                      <ul className="list-none p-0 m-0 flex flex-col gap-3">
                        {(section.features ?? []).map((item, i) => (
                          <li key={i} className="flex items-center gap-2.5 text-sm font-medium text-[#0f172a]">
                            <span className="material-symbols-outlined text-xl text-[#4BA18C] flex-shrink-0">
                              {item.icon || "check_circle"}
                            </span>
                            <div>
                              {ti(item, "title") && (
                                <span className="font-bold">{ti(item, "title")} </span>
                              )}
                              {ti(item, "description") && (
                                <span className="text-[#475569]">{ti(item, "description")}</span>
                              )}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </section>
              </ScrollReveal>
            );
          }
          return null;
        })}
      </div>
    </>
  );
};

export default Yazilim;